var map = {
	"./desk_preland_1.jpg": 1033,
	"./desk_preland_2.jpg": 1034,
	"./desk_preland_3.jpg": 1035,
	"./desk_preland_4.jpg": 1036,
	"./desk_preland_5.jpg": 1037,
	"./desk_preland_6.jpg": 1038,
	"./desk_preland_7.jpg": 1039,
	"./desk_preland_8.jpg": 1040,
	"./desk_preland_9.jpg": 1041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1032;